const WORDS = ["Move freely", "Live boldly", "Six signature colors", "Worn four ways", "Silver metal emblem", "Made for everyday movement"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {WORDS.map((w) => (
      <span key={w} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-4xl italic text-ink md:px-12 md:text-6xl">{w}</span>
        <img src="/img/emblem.png" alt="" className="h-8 w-8 md:h-10 md:w-10" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="overflow-hidden border-y border-line bg-ivory py-8 md:py-10" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
